import { emptystate } from '@kid/sharpui/widget/output/all/tokens';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { BLOCK_PREFIX } from './utils/constants';
import Icon from './icon';
import Button from './button';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createCommentVNode, createBlock, toDisplayString, renderSlot, withCtx, createTextVNode } from 'vue';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * kid token
   */
  token: propTypes.string(),
  /**
   * 图标名称或图片链接，等同于 Icon 组件的 name 属性
   */
  iconName: propTypes.string(),
  /**
   * 自定义 icon 类名前缀，用于自定义图标
   */
  classPrefix: propTypes.string().def("".concat(BLOCK_PREFIX, "-icon")),
  /**
   * 自定义 icon 字体基础类名
   */
  fontClassName: propTypes.string().def("".concat(BLOCK_PREFIX, "-icon")),
  /**
   * 图标颜色
   */
  iconColor: propTypes.string(),
  /**
   * 图标大小
   */
  iconSize: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(96),
  /**
   * 标题（最多不超过 14 个字）
   */
  title: propTypes.string().def(''),
  /**
   * 描述（最多展示三行）
   */
  description: propTypes.string().def(''),
  /**
   * 按钮文案
   */
  buttonText: propTypes.string().def(''),
  /**
   * 按钮类型
   */
  buttonType: propTypes.string().def(''),
  /**
   * 链接文案
   */
  linkText: propTypes.string().def('')
};
var BTN_CLICK_EVENT = 'btn-click';
var LINK_CLICK_EVENT = 'link-click';
var emits = [BTN_CLICK_EVENT, LINK_CLICK_EVENT];

var _components;
var _createComponent = createComponent('empty-state'),
  create = _createComponent.create,
  className = _createComponent.className;
// 标题字数限制
var TITLE_MAX_COUNT = 14;
var script = create({
  components: (_components = {}, _defineProperty(_components, Icon.name, Icon), _defineProperty(_components, Button.name, Button), _components),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    function onBtnClick(e) {
      emit(BTN_CLICK_EVENT, e);
    }
    function onLinkClick(e) {
      emit(LINK_CLICK_EVENT, e);
    }
    // 获取 kid-token 对应的 button token
    function getButtonToken(token) {
      return emptystate[token] && emptystate[token].button || 'style_button_medium_orange_bg';
    }
    return {
      className: className,
      TITLE_MAX_COUNT: TITLE_MAX_COUNT,
      onBtnClick: onBtnClick,
      getButtonToken: getButtonToken,
      onLinkClick: onLinkClick
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_icon = resolveComponent("sp-icon");
  var _component_sp_button = resolveComponent("sp-button");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createCommentVNode(" 图标 "), _ctx.iconName ? (openBlock(), createBlock(_component_sp_icon, {
    key: 0,
    "class": normalizeClass("".concat(_ctx.className, "__icon")),
    name: _ctx.iconName,
    classPrefix: _ctx.classPrefix,
    fontClassName: _ctx.fontClassName,
    color: _ctx.iconColor,
    size: _ctx.iconSize
  }, null, 8 /* PROPS */, ["class", "name", "classPrefix", "fontClassName", "color", "size"])) : createCommentVNode("v-if", true), createCommentVNode(" 标题 "), _ctx.title ? (openBlock(), createElementBlock("div", {
    key: 1,
    "class": normalizeClass("".concat(_ctx.className, "__title"))
  }, toDisplayString(_ctx.title.slice(0, _ctx.TITLE_MAX_COUNT)), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true), createCommentVNode(" 描述 "), renderSlot(_ctx.$slots, "description", {}, function () {
    return [_ctx.description ? (openBlock(), createElementBlock("div", {
      key: 0,
      "class": normalizeClass("".concat(_ctx.className, "__description"))
    }, toDisplayString(_ctx.description), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true)];
  }), createCommentVNode(" 按钮 "), _ctx.buttonText ? (openBlock(), createBlock(_component_sp_button, {
    key: 2,
    "class": normalizeClass(["".concat(_ctx.className, "__button"), _defineProperty({}, "".concat(_ctx.token, "__button"), !!_ctx.token)]),
    type: _ctx.buttonType,
    token: _ctx.token ? _ctx.getButtonToken(_ctx.token) : '',
    onClick: _ctx.onBtnClick
  }, {
    "default": withCtx(function () {
      return [createTextVNode(toDisplayString(_ctx.buttonText), 1 /* TEXT */)];
    }),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "type", "token", "onClick"])) : createCommentVNode("v-if", true), createCommentVNode(" 链接 "), _ctx.linkText ? (openBlock(), createElementBlock("a", {
    key: 3,
    "class": normalizeClass(["".concat(_ctx.className, "__link"), _defineProperty({}, "".concat(_ctx.token, "__link"), !!_ctx.token)]),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.onLinkClick && _ctx.onLinkClick.apply(_ctx, arguments);
    })
  }, toDisplayString(_ctx.linkText), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/empty-state/empty-state.vue";

/*
 * @Description: EmptyState 空状态组件导出文件
 * @Author: duqiao@kuaishou.com
 * @Date: 2022-03-15 17:20:14
 * @LastEditors: zhoushichao@kuaishou.com
 * @LastEditTime: 2023-02-02 11:00:55
 */
var _EmptyState = script;

export { _EmptyState as default };
